<template>
    <div>
        <div class="d-flex align-items-center" style="margin-top: 12px;">
            <h5 class="mb-0">Добавление элемента</h5>
            <div class="d-flex ml-auto">
                <template>
                    <div>
                        <b-icon
                            v-if="$mq != 'sm'"
                            icon="search"
                            scale="1.3"
                            class="table-input-search_icon"
                            variant="secondary"
                        />
                        <input class="form-control table-input-search" id="table-input-search" type="search" placeholder="Поиск" v-model="filter">
                    </div>
                </template>
            </div>
        </div>
        <div class="mt-3 mb-3">
            <span
                class="cursor-pointer text-uppercase"
                @click="showAddInput = true"
            >
                Добавить свойство
                <i class="bx bxs-add-to-queue cursor-pointer ml-2"></i>
            </span>
            <div
                v-if="showAddInput"
                class="d-flex mb-2 flex-column"
            >
                <b-row class="my-1">
                    <b-col sm="3">
                        <label for="input-new-name">Название</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            v-model="newReference.name"
                            id="input-new-name"
                            size="sm"
                        />
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="3">
                        <label for="input-slug">Название slug</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            v-model="newReference.slug"
                            id="input-slug"
                            size="sm"
                        />
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="3">
                        <label for="input-reference_id">Parent ID, if empty = 0</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            v-model="newReference.parent_id"
                            id="input-reference_id"
                            size="sm"
                        />
                    </b-col>
                </b-row>
                <div class="d-flex mb-2">
                    <b-button
                        size="md"
                        class="ml-auto btn btn-primary"
                        @click="closeAddInput"
                    >
                        Отмена
                    </b-button>
                    <b-button
                        size="md"
                        :class="[newReference.name === '' ? 'disabled' : '', 'ml-2', 'btn', 'btn-primary']"
                        @click="addNewReference"
                    >
                        Сохранить
                    </b-button>
                </div>
            </div>
        </div>

        <h5>Список ссылок</h5>
        <b-list-group v-if="isLoad">
            <b-list-group-item
                v-for="(reference, index) in filtredItems"
                :key="reference.id"
                class="flex-column align-items-start mb-2 main-column"
            >
                <div class="d-flex w-100 justify-content-between align-items-center reference">
                    <span class="cursor-pointer" @click="showProperties(index)">ID: {{ reference.id }}, {{ reference.name }}</span>
                    <div class="d-flex align-items-center">
                        <i class="bx bxs-trash cursor-pointer mr-2" v-if="!reference.properties.length" @click="toTrashReference(reference.id)"></i>
                        <i class="bx bx-add-to-queue cursor-pointer mr-2" @click="showAddNewPropertyInput(reference.id)"></i>
                        <i class="bx bx-edit cursor-pointer mr-2" @click="showEditReferenceInput(reference.id)"></i>
                        <b-badge variant="primary" pill>{{ reference.properties.length }}</b-badge>
                    </div>
                </div>

                <div
                    v-if="reference.properties.length"
                    class="properties hidden"
                >
                    <div
                        v-for="(property, id) in reference.properties"
                        :key="id + 0"
                        class="list-group-item d-flex justify-content-between align-items-start flex-column property-column"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <span class="property">ID: {{ property.id }}, {{ property.name }},  ordering number: {{ property.ordering_number }}</span>
                            <div>
                                <i class="bx bx-edit cursor-pointer mr-2" @click="showEditPropertyInput(property.id)"></i>
                                <i class="bx bxs-trash cursor-pointer" @click="toTrashProperty(property.id, index)"></i>
                            </div>
                        </div>

                        <div v-if="tempEditPropertyId === property.id" class="d-flex flex-column w-100">
                            <b-row class="my-1">
                                <b-col sm="4">
                                    <label :for="`input-property-name-${property.id}`">Название, id: {{ property.id }}</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input
                                        v-model="property.name"
                                        :id="`input-property-name-${property.id}`"
                                        size="sm"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="4">
                                    <label :for="`input-property-reference_id-${property.id}`">reference id</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input
                                        v-model="property.reference_id"
                                        :id="`input-property-reference_id-${property.id}`"
                                        size="sm"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="4">
                                    <label :for="`input-property-need_reference-${property.id}`">need reference, default = 0</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input
                                        v-model="property.need_reference"
                                        :id="`input-property-need_reference-${property.id}`"
                                        size="sm"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="4">
                                    <label :for="`input-property-ordering_number-${property.id}`">ordering number, default = 10</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input
                                        v-model="property.ordering_number"
                                        :id="`input-property-ordering_number-${property.id}`"
                                        size="sm"
                                    />
                                </b-col>
                            </b-row>

                            <div class="d-flex mb-2">
                                <b-button
                                    size="md"
                                    class="ml-auto btn btn-primary"
                                    @click="showEditPropertyInput(null)"
                                >
                                    Отмена
                                </b-button>
                                <b-button
                                    size="md"
                                    class="ml-2 btn btn-primary"
                                    @click="saveEditProperty(property)"
                                >
                                    Сохранить
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="tempEditReferenceId === reference.id" class="d-flex flex-column mt-2">
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label :for="`input-name-${reference.id}`">Название</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input
                                v-model="reference.name"
                                :id="`input-name-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label :for="`input-slug-${reference.id}`">Название slug</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input
                                v-model="reference.slug"
                                :id="`input-slug-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label :for="`input-reference_id-${reference.id}`">Parent ID, if empty = 0</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input
                                v-model="reference.parent_id"
                                :id="`input-reference_id-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <div class="d-flex mb-2">
                        <b-button
                            size="md"
                            class="ml-auto btn btn-primary"
                            @click="showEditReferenceInput(null)"
                        >
                            Отмена
                        </b-button>
                        <b-button
                            size="md"
                            class="ml-2 btn btn-primary"
                            @click="saveEditReference(reference, reference.id)"
                        >
                            Сохранить
                        </b-button>
                    </div>
                </div>

                <div v-if="tempNewPropertyId === reference.id" class="d-flex flex-column mt-2">
                    <b-row class="my-1">
                        <b-col sm="4">
                            <label :for="`input-new-property-name-${reference.id}`">Название</label>
                        </b-col>
                        <b-col sm="8">
                            <b-form-input
                                v-model="newProperty.name"
                                :id="`input-new-property-name-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="4">
                            <label :for="`input-new-property-reference-id-${reference.id}`">Reference id</label>
                        </b-col>
                        <b-col sm="8">
                            <b-form-input
                                v-model="reference.id"
                                :id="`input-new-property-reference-id-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="4">
                            <label :for="`input-new-property-need-reference-${reference.id}`">Need reference, default = 0</label>
                        </b-col>
                        <b-col sm="8">
                            <b-form-input
                                v-model="newProperty.need_reference"
                                :id="`input-new-property-need-reference-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="4">
                            <label :for="`input-new-property-reference_id-${reference.id}`">Ordering number, default = 10</label>
                        </b-col>
                        <b-col sm="8">
                            <b-form-input
                                v-model="newProperty.ordering_number"
                                :id="`input-new-property-reference_id-${reference.id}`"
                                size="sm"
                            />
                        </b-col>
                    </b-row>

                    <div class="d-flex mb-2">
                        <b-button
                            size="md"
                            class="ml-auto btn btn-primary"
                            @click="showAddNewPropertyInput(null)"
                        >
                            Отмена
                        </b-button>
                        <b-button
                            size="md"
                            :class="[newProperty.name === '' ? 'disabled' : '', 'ml-2', 'btn', 'btn-primary']"
                            @click="addNewProperty(index, reference.id)"
                        >
                            Сохранить
                        </b-button>
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>

        <b-overlay
            :show="!isLoad"
            rounded
            opacity="0.6"
            spinner-variant="success"
            class="mx-auto mt-5"
        ></b-overlay>
    </div>
</template>

<script>
import { API_REFERENCE, API_REFERENCE_PROPERTIES } from '@/constants';

const initialReference = () => (
    {
        name: '',
        properties: [],
        slug: '',
        parent_id: 0
    }
);

const initialProperty = () => (
    {
        name: '',
        reference_id: '',
        need_reference: 0,
        ordering_number: 10
    }
);

export default {
    data() {
        return {
            references: [],
            showAddInput: false,
            newReference: {
                name: '',
                properties: [],
                slug: '',
                parent_id: 0
            },
            newProperty: {
                name: '',
                reference_id: '',
                need_reference: 0,
                ordering_number: 10
            },
            filter: '',
            isLoad: false,
            tempEditReferenceId: null,
            tempNewPropertyId: null,
            tempEditPropertyId: null,
        };
    },

    computed: {
        filtredItems() {
            if (this.references.length) {
                return this.references.filter(reference => {
                    if (
                        reference.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1 ||
                        reference.properties.filter(property => {
                            return property.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
                        }).length !== 0
                    ) {
                        return reference
                    }
                })
            } else {
                return []
            }
        }
    },

    methods: {
        getReferences() {
            this.isLoad = false;
            axios.get(`${API_REFERENCE}?easylist=true`)
                .then(({ data }) => {
                    this.references = data;
                    this.newReference = initialReference();
                    this.isLoad = true;
                })
                .catch(e => console.log(e))
        },

        showProperties(id) {
            let el = document.querySelectorAll('.reference')[id];
            if (el.nextElementSibling && el.nextElementSibling.classList.contains('properties')) {
                if (el.classList.contains('active')) {
                    el.nextElementSibling.classList.toggle('hidden');
                }
                el.classList.toggle('active');
                if (el.classList.contains('active')) {
                    el.nextElementSibling.classList.toggle('hidden');
                }
            }
        },

        showEditReferenceInput(refId) {
            this.tempNewPropertyId = null;
            this.tempEditPropertyId = null;
            this.tempEditReferenceId = refId;
        },

        showEditPropertyInput(propId) {
            this.tempNewPropertyId = null;
            this.tempEditReferenceId = null;
            this.tempEditPropertyId = propId;
        },

        showAddNewPropertyInput(refId) {
            this.tempEditReferenceId = null;
            this.tempEditPropertyId = null;
            this.tempNewPropertyId = refId;
            this.newProperty = initialProperty();
        },

        closeAddInput() {
            this.showAddInput = false;
            this.newReference = initialReference();
        },

        addNewReference() {
            if (this.newReference.name !== '' && this.newReference.parent_id == 0) {
                delete this.newReference.parent_id;
                axios
                    .post(API_REFERENCE, this.newReference)
                    .then((data) => {
                        this.references.push(data.data);
                        this.newReference = initialReference();
                        this.showAddInput = false;
                    });
            }
        },

        addNewProperty(index, reference_id) {
            this.newProperty.reference_id = reference_id;
            axios
                .post(API_REFERENCE_PROPERTIES, this.newProperty)
                .then(data => {
                    this.newProperty.id = data.data.id;
                    this.references[index].properties.unshift(this.newProperty);
                    this.showAddNewPropertyInput(null);
                    this.newProperty = initialProperty();
            });
        },

        // не сохраняется если есть старый parent_id = 0
        saveEditReference(item, id) {
            if (item.parent_id == 0) {
                delete item.parent_id
            }
            axios.put(`${API_REFERENCE}/${id}`, item)
                .then(() => {
                    this.showEditReferenceInput(null);
                    this.newReference = initialReference();
                });
        },

        saveEditProperty(item) {
            axios.put(`${API_REFERENCE_PROPERTIES}/${item.id}`, item)
            .then(() => {
                this.showEditPropertyInput(null);
            });
        },

        toTrashReference(id) {
            axios
                .delete(`${API_REFERENCE}/${id}`)
                .then((data) => {
                    this.references = this.references.filter(item => item.id !== id)
            });
        },

        toTrashProperty(propertyId, referenceId) {
            axios
                .delete(`${API_REFERENCE_PROPERTIES}/${propertyId}`)
                .then((data) => {
                    this.references[referenceId].properties = this.references[referenceId].properties.filter(item => item.id !== propertyId);
            });
        },
    },

    mounted() {
        this.getReferences();
    },
};
</script>

<style scoped lang="scss">
.reference {
    margin-bottom: 0px;
    transition: margin-bottom 200ms ease;
    &.active {
        margin-bottom: 5px;
        transition: margin-bottom 200ms ease;
    }
}
.properties {
    max-height: 400px;
    transition: max-height 200ms ease;
    overflow-y: auto;
}
.hidden {
    max-height: 0px;
    transition: max-height 200ms ease;
    overflow: hidden;
}
</style>
